// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"button_wrapper__9Vukd"};